import { scrollToId } from "@/lib/scroll";
import { FadeUp, SectionTag } from "@/components/motion";
import { ServiceCard } from "@/components/ServiceCard";

const PARTY_IMG = "/images/party-mirror.jpg";

const SERVICES = [
  {
    id: "appointment",
    testid: "service-card-appointment",
    tag: "One-on-One",
    title: "Individual Studio Session",
    copy: "A private fitting, just you and the chain. Perfect for a personal milestone, a gift, or matching pieces with someone you love.",
    points: [
      "15–20 minute private session",
      "Custom fit to wrist or ankle",
      "Charms & connectors available",
      "Ideal for gifts & milestones",
    ],
    cta: "Book One-on-One",
  },
  {
    id: "party",
    testid: "service-card-party",
    tag: "Groups & Events",
    title: "Private Parties & Pop-Ups",
    copy: "We bring the studio to you. Every guest leaves with a welded piece — and a memory that literally never comes off.",
    points: [
      "Bridal showers & bachelorettes",
      "Birthdays & girls' night out",
      "Corporate & brand events",
      "We travel to your venue",
    ],
    cta: "Plan a Party",
    img: PARTY_IMG,
    imgAspectClass: "aspect-[4/5]",
  },
];

export default function Services({ onSelectType }) {
  const choose = (type) => {
    onSelectType(type);
    scrollToId("booking");
  };

  return (
    <section id="services" data-testid="services-section" className="py-20 sm:py-28 lg:py-36">
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
        <FadeUp className="max-w-2xl mb-14 sm:mb-20">
          <SectionTag>Services</SectionTag>
          <h2 className="mt-3 font-serif tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl leading-tight">
            One quiet appointment,<br />
            <span className="italic text-gold">or the whole party.</span>
          </h2>
        </FadeUp>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 items-start">
          {SERVICES.map((s, i) => (
            <FadeUp key={s.id} delay={i * 0.12}>
              <ServiceCard service={s} onChoose={choose} />
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
